__webpack_require__.p = "/portfolios/v1/kleamerkuri/";